exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quotes-icon[data-v-c9d0e830]{left:-28px;top:3px}", ""]);

// exports
